import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useProjectContextStore } from '@/stores/projectContext'

export function useProjectPermissions() {
  const auth = useAuthStore()
  const projectContext = useProjectContextStore()

  const membershipRole = computed(() => projectContext.activeProjectMembershipRole)

  const isProjectViewer = computed(
    () => auth.user?.role === 'admin' && membershipRole.value === 'viewer'
  )

  const isProjectContributor = computed(
    () => auth.user?.role === 'admin' && membershipRole.value === 'contributor'
  )

  const canMutateInProject = computed(() => {
    if (auth.user?.role === 'superadmin') return true
    if (auth.user?.role !== 'admin') return false
    const r = membershipRole.value
    return r === 'project_owner' || r === 'contributor'
  })

  return {
    membershipRole,
    isProjectViewer,
    isProjectContributor,
    canMutateInProject
  }
}
